import { Action } from '@ngrx/store';

export const RESET_ALL_STATE = '[Navigation Component] ResetAllState';

export class ResetAllState implements Action { readonly type = RESET_ALL_STATE; constructor() { } }

export type Actions
  =
  ResetAllState ;
